<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <v-icon style="font-size: 30px; height: 30px; margin-top:8.75svh; margin-left: 2svw; margin-right: 2svw;" color="#3F616C">
                        error_outline</v-icon>
                    <p
                        style="margin-top:1svh; margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px; font-weight: 400;">
                        Si NO desea evacuar de nuevo,</p>
                    <p
                        style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px; font-weight: 300;">
                        entonces ha finalizado el proceso.</p>
                    <p
                        style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px; font-weight: 400;">
                        Ahora acuda al hospital,</p>
                    <p
                        style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px; font-weight: 300;">
                        a la mayor brevedad</p>
                    <p
                        style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px; font-weight: 400;">
                        para realizar la prueba requerida.</p>
                    <v-icon style="font-size: 30px; height: 30px; margin-top:5svh; margin-left: 2svw; margin-right: 2svw;" color="#3F616C">
                        error_outline</v-icon>
                    <p
                        style="margin-top:1svh; margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px; font-weight: 400;">
                        Si desea evacuar de nuevo,</p>
                    <p
                        style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px; font-weight: 300;">
                        realice una foto</p>
                    <p
                        style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px; font-weight: 300;">
                        de la nueva deposición</p>
                    <div style="display: flex; flex-flow: column; justify-content: flex-end; flex: 1 1 auto">
                        <v-btn elevation="12" v-on:click="click();"
                            style="margin-left: auto; margin-right: auto; width: 208px; height: 69px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 17px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                            <b>Hacer nueva foto</b>
                        </v-btn>
                        <p
                            style="margin-top:3.1svh; margin-left: auto; margin-right: auto; margin-bottom: 6.4svh; font-family: Lato; font-style: normal; color: #3F616C; text-align: center; font-size: 24px;">
                            ¡Gracias por colaborar!</p>
                    </div>
                </v-card>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import CardNav from './CardNav.vue';
import { nextScreen } from '../router/utils.js';

export default {
    name: 'EndTreatmentHospital',
    components: {
        CardNav
    },
    methods: {
        back() {
            nextScreen(this.$router, '/accesscode');
        },
        click() {
            nextScreen(this.$router, '/lastdeposited');
        }
    },
}
</script>

<style>

i.v-icon.v-icon:after{
    height: 0%;
}

</style>



// WEBPACK FOOTER //
// src/components/EndTreatmentHospital.vue